import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Button } from '@lusha-ui/button';
import { GridContainer } from '@lusha-ui/core';
import { Text } from '@lusha-ui/text';
import { colors } from '@lusha-ui/theme';
import invariant from 'invariant';
import qs from 'qs';
import React, { useMemo, useState } from 'react';
import { useAsyncHandler } from 'react-hooks-async-handlers';
import api from '../api/api';
import svgUrl from '../assets/SendIllustration.svg';
import RadioGroup from './RadioGroup';
import UnsubscribeSuccess from './UnsubscribeSuccess';
function Wizard() {
    const [option, setOption] = useState(null);
    const [message, setMessage] = useState('');
    const token = useMemo(() => {
        const { location } = window;
        const search = location.search.replace(/^\?/, '');
        const params = qs.parse(search);
        return params === null || params === void 0 ? void 0 : params.token;
    }, []);
    const actionSubmit = useAsyncHandler(() => __awaiter(this, void 0, void 0, function* () {
        invariant(token, 'Invalid token. Unsubscribe link is invalid');
        yield api.unsubscribe({ token, option, message: option === 'other' ? message : undefined });
    }));
    if (actionSubmit.isDone) {
        return _jsx(UnsubscribeSuccess, {});
    }
    return (_jsx(GridContainer, { justifyContent: 'center', alignItems: 'center', css: css `
        height: 100%;
      `, children: _jsxs(GridContainer, { flexDirection: 'column', 
            // min-height is needed to avoid jumping when other`s trext-area is opened
            css: css `
          min-height: 386px;
          position: relative;
        `, children: [_jsx("img", { src: svgUrl, alt: '', css: css `
            width: 230px;
            position: absolute;
            top: -85px;
            left: -196px;
          ` }), _jsx(Text, { variant: 'h3-s', children: "Confirm your unsubscription" }), _jsx(Text, { variant: 'body-2-r', css: css `
            margin-bottom: 24px;
          `, children: "You\u2019re about to stop receiving emails from this sender." }), _jsx(RadioGroup, { option: option, setOption: setOption, message: message, setMessage: setMessage }), _jsx(GridContainer, { justifyContent: 'flex-end', css: css `
            padding-top: 24px;
            width: 100%;
          `, children: _jsx(Button, { variant: 'primary', size: 'small', onClick: actionSubmit.execute, loading: actionSubmit.isLoading, children: "Submit" }) }), _jsx(Text, { variant: 'body-3-r', color: colors.text_and_icons.negative.DEFAULT, textAlign: 'right', css: css `
            margin-top: 10px;
          `, children: actionSubmit.error })] }) }));
}
export default Wizard;
